import * as React from 'react';

import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface FilterCheckboxItemProps {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  children: React.ReactNode;
  className?: string;
}

/**
 * Row height in px. Must match the `h-8` class on the wrapper below.
 * VirtualizedTagList uses it as the fixed row size for the virtualizer.
 */
export const FILTER_CHECKBOX_ITEM_HEIGHT_PX = 32;

/**
 * Reusable checkbox item component for filters with hover-to-show behavior.
 * Checkboxes are hidden by default and appear on hover, except when checked.
 */
export const FilterCheckboxItem: React.FC<FilterCheckboxItemProps> = ({
  id,
  checked,
  onCheckedChange,
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        'group flex h-8 items-center space-x-2 rounded-sm py-1.5 pl-2 hover:bg-selected-soft',
        className
      )}
    >
      <Checkbox
        id={id}
        className={cn(
          'transition-opacity',
          checked ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
        )}
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
      <Label htmlFor={id} className="flex min-w-0 flex-1 cursor-pointer items-center">
        <span className="truncate">{children}</span>
      </Label>
    </div>
  );
};
